import axiosInstance from "./axiosConfig";
import { handleApiError } from "./errorHandler";

// ------------------------------ Common API -----------------------------

export const user_session_data_admin_api = async (data) => {
    try {
        console.log(data);
        const response = await axiosInstance.get(`/api/user_session_data_admin?userid=${data}`);
        return response;
    } catch (error) {
        throw handleApiError(error, 'user_session_data_admin_api');
    }
};

export const feature_program_api = async (data) => {
    try {
        console.log(data);
        const response = await axiosInstance.post(`/api/feature_program`, data);
        return response;
    } catch (error) {
        throw handleApiError(error, 'feature_program_api');
    }
};

// ------------------------------ Customer Data API -----------------------------

export const receive_custdata = async ({customerid, userid}) => {
    try {
        console.log("c_id, u_id", customerid, userid);
        const response = await axiosInstance.get(`/api/receive_custdata?customerid=${customerid}&userid=${userid}`);
        return response;
    } catch (error) {
        throw handleApiError(error, 'receive_custdata');
    }
};

export const update_custdata = async (data) => {
    try {
        console.log(data);
        const response = await axiosInstance.put(`/api/selection_savecust`, data);
        return response;
    } catch (error) {
        throw handleApiError(error, 'update_custdata');
    }
};

export const receive_homecountry_sectors = async (needlist) => {
    try {
        console.log(needlist);
        const response = await axiosInstance.get(`/api/receive_homecountry_sectors?needlist=${needlist}`);
        return response;
    } catch (error) {
        throw handleApiError(error, 'receive_homecountry_sectors');
    }
};

export const upload_brandIcon = async (data) => {
    try {
        console.log(data);
        const response = await axiosInstance.post(`/api/upload_brandIcon`, data);
        return response;
    } catch (error) {
        throw handleApiError(error, 'upload_brandIcon');
    }
};

// ------------------------------ LocationList API -----------------------------

export const sectionselect_locationlist_api = async (data) => {
    try {
        console.log(data);
        const response = await axiosInstance.get(`/api/sectionselect_locationlist?customerid=${data}`);
        return response;
    } catch (error) {
        throw handleApiError(error, 'sectionselect_locationlist_api');
    }
};

export const needlist_loccountry_locsectors_api = async (data) => {
    try {
        console.log(data);
        const response = await axiosInstance.get(`/api/needlist_loccountry_locsectors?needlist=${data}`);
        return response;
    } catch (error) {
        throw handleApiError(error, 'needlist_loccountry_locsectors_api');
    }
};

export const add_new_loc = async (data) => {
    try {
        console.log(data);
        const response = await axiosInstance.post(`/api/selection_saveloc`, data);
        return response;
    } catch (error) {
        throw handleApiError(error, 'add_new_loc');
    }
};

export const update_location = async (data) => {
    try {
        console.log(data);
        const response = await axiosInstance.get(`/api/selection_locchange`, {params: data});
        return response;
    } catch (error) {
        throw handleApiError(error, 'update_location');
    }
};

// ------------------------------ Admin/User API -----------------------------

export const admin_user_data = async (data) => {
    try {
        console.log(data);
        const response = await axiosInstance.post(`/api/sectionselect_adminuser`, data);
        return response;
    } catch (error) {
        throw handleApiError(error, 'admin_user_data');
    }
};

export const add_new_admin_user = async (data) => {
    try {
        console.log(data);
        const response = await axiosInstance.post(`/api/add_change_delete_admin`, data);
        return response;
    } catch (error) {
        throw handleApiError(error, 'add_new_admin_user');
    }
};

export const update_change_admin_user = async (data) => {
    try {
        console.log(data);
        const response = await axiosInstance.post(`/api/add_change_delete_admin`, data);
        return response;
    } catch (error) {
        throw handleApiError(error, 'update_change_admin_user');
    }
};

export const delete_admin_user = async (data) => {
    try {
        console.log(data);
        const response = await axiosInstance.post(`/api/add_change_delete_admin`, data);
        return response;
    } catch (error) {
        throw handleApiError(error, 'delete_admin_user');
    }
};

// ------------------------------ Admin/User Location API -----------------------------

export const admin_user_loc_data = async (data) => {
    try {
        console.log(data);
        const response = await axiosInstance.post(`/api/sectionselect_admuserloc`, data);
        return response;
    } catch (error) {
        throw handleApiError(error, 'admin_user_loc_data');
    }
};

export const add_new_loc_list = async (data) => {
    try {
        console.log(data);
        const response = await axiosInstance.post(`/api/section_newuserloc`, data);
        return response;
    } catch (error) {
        throw handleApiError(error, 'add_new_loc_list');
    }
};

export const add_admin_user_location = async (data) => {
    try {
        console.log(data);
        const response = await axiosInstance.post(`/api/add_del_adminloc`, data);
        return response;
    } catch (error) {
        throw handleApiError(error, 'add_admin_user_location');
    }
};

export const delete_admin_user_location = async (data) => {
    try {
        console.log(data);
        const response = await axiosInstance.post(`/api/add_del_adminloc`, data);
        return response;
    } catch (error) {
        throw handleApiError(error, 'delete_admin_user_location');
    }
};

// ------------------------------ Custom Topic Data API -----------------------------

export const receive_custom_topic_data = async ({customerid}) => {
    try {
        console.log("customer_id", customerid);
        const response = await axiosInstance.get(`/api/sectionselect_customtopic?customerid=${customerid}`);
        return response;
    } catch (error) {
        throw handleApiError(error, 'receive_custom_topic_data');
    }
};

export const update_custom_topic_data = async (data) => {
    try {
        console.log(data);
        const response = await axiosInstance.put(`/api/selection_changecuztop`, data);
        return response;
    } catch (error) {
        throw handleApiError(error, 'update_custom_topic_data');
    }
};

export const receive_custom_topic_status = async () => {
    try {
        const response = await axiosInstance.get(`/api/selection_viewcuzstatus`);
        return response;
    } catch (error) {
        throw handleApiError(error, 'receive_custom_topic_status');
    }
};

export const update_custom_topic_status = async (data) => {
    try {
        console.log(data);
        const response = await axiosInstance.put(`/api/selection_cuztopchange`, data);
        return response;
    } catch (error) {
        throw handleApiError(error, 'update_custom_topic_status');
    }
};

export const receive_status_info = async () => {
    try {
        const response = await axiosInstance.get(`/api/selection_statusinfo2`);
        return response;
    } catch (error) {
        throw handleApiError(error, 'receive_status_info');
    }
};

export const add_new_custom_topic = async (data) => {
    try {
        console.log(data);
        const response = await axiosInstance.put(`/api/selection_addcuztop`, data);
        return response;
    } catch (error) {
        throw handleApiError(error, 'add_new_custom_topic');
    }
};

// ---------------------------- Standard Topic api -------------------------

export const sectionselect_stdtopics_api = async (data) => {
    try {
        console.log(data);
        const response = await axiosInstance.get(`/api/sectionselect_stdtopics?customerid=${data}`,{customerid:data});
        return response;
    } catch (error) {
        throw handleApiError(error, 'sectionselect_stdtopics_api');
    }
};

export const selection_newtopic_api = async (data) => {
    try {
        console.log(data);
        const response = await axiosInstance.post(`/api/selection_newtopic`,data);
        return response;
    } catch (error) {
        throw handleApiError(error, 'selection_newtopic_api');
    }
};

export const selection_viewstatus_api = async () => {
    try {
        const response = await axiosInstance.get(`/api/selection_viewstatus`);
        return response;
    } catch (error) {
        throw handleApiError(error, 'selection_viewstatus_api');
    }
};

export const selection_topicstatus_api = async (data) => {
    try {
        console.log(data);
        const response = await axiosInstance.put(`/api/selection_topicstatus`,data);
        return response;
    } catch (error) {
        throw handleApiError(error, 'selection_topicstatus_api');
    }
};

export const selection_bulk_topicstatus_api = async (data) => {
    try {
        console.log(data);
        const response = await axiosInstance.put(`/api/selection_bulk_topicstatus`,data);
        return response;
    } catch (error) {
        throw handleApiError(error, 'selection_bulk_topicstatus_api');
    }
};

export const selection_statusinfo_api = async () => {
    try {
        const response = await axiosInstance.get(`/api/selection_statusinfo`);
        return response;
    } catch (error) {
        throw handleApiError(error, 'selection_statusinfo_api');
    }
};

// ------------------------Activetoploc apis--------------------

export const sectionselect_topiclocs_api = async (data) => {
    try {
        console.log(data);
        const response = await axiosInstance.get(`/api/sectionselect_topiclocs?customerid=${data}`,{customerid:data});
        return response;
    } catch (error) {
        throw handleApiError(error, 'sectionselect_topiclocs_api');
    }
};

export const selection_statustoploc_api = async (data) => {
    try {
        console.log(data);
        const response = await axiosInstance.put(`/api/selection_statustoploc`,data);
        return response;
    } catch (error) {
        throw handleApiError(error, 'selection_statustoploc_api');
    }
};

export const selection_newtoploc_api = async (data) => {
    try {
        console.log(data);
        const response = await axiosInstance.post(`/api/selection_newtoploc`,data);
        return response;
    } catch (error) {
        throw handleApiError(error, 'selection_newtoploc_api');
    }
};

export const selection_addtopicloc_api = async (data) => {
    try {
        console.log(data);
        const response = await axiosInstance.post(`/api/selection_addtopicloc`,data);
        return response;
    } catch (error) {
        throw handleApiError(error, 'selection_addtopicloc_api');
    }
};

// ---------------------user topic permision api-------------------------------

export const sectionselect_usertopperm_api = async (data) => {
    try {
        console.log(data);
        const response = await axiosInstance.post(`/api/sectionselect_usertopperm`,data);
        return response;
    } catch (error) {
        throw handleApiError(error, 'sectionselect_usertopperm_api');
    }
};

export const selection_changepriv_api = async (data) => {
    try {
        console.log(data);
        const response = await axiosInstance.put(`/api/selection_changepriv`,data);
        return response;
    } catch (error) {
        throw handleApiError(error, 'selection_changepriv_api');
    }
};

export const selection_deleteuser_api = async (data) => {
    try {
        console.log(data);
        const response = await axiosInstance.post(`/api/selection_deleteuser`,data);
        return response;
    } catch (error) {
        throw handleApiError(error, 'selection_deleteuser_api');
    }
};

export const getAdminPDF_Api = async () => {
    try {
        const response = await axiosInstance.get(`/api/getpdf?type=Admin`);
        console.log("getpdfA_api",response);
        return response;
    } catch (error) {
        throw handleApiError(error, 'getAdminPDF_Api');
    }
};

export const getClientPDF_Api = async () => {
    try {
        const response = await axiosInstance.get(`/api/getpdf?type=Client`);
        console.log("getpdfC_api",response);
        return response;
    } catch (error) {
        throw handleApiError(error, 'getClientPDF_Api');
    }
};

export const getPDF = async (type) => {
    try {
        const response = await axiosInstance.get(`/api/getpdf?type=${type}`);
        console.log("getPDF",response);
        return response;
    } catch (error) {
        throw handleApiError(error, 'getPDF');
    }
};

export const Add_User_to_LT = async (data) => {
    try {
        const response = await axiosInstance.post(`/api/selection_addemail`, data, {
            headers: { Authorization: "Bearer " + localStorage.getItem("token") },
        });
        return response;
    } catch (error) {
        throw handleApiError(error, 'Add_User_to_LT');
    }
};

//  support menu
export const receive_newcust_field = async (needlist) => {
    try {
        console.log(needlist);
        const response = await axiosInstance.get(`/api/receive_newcust_field?needlist=${needlist}`);
        return response;
    } catch (error) {
        throw handleApiError(error, 'receive_newcust_field');
    }
};

export const Add_new_cust_data = async (data) => {
    try {
        console.log(data);
        const response = await axiosInstance.put(`/api/Add_new_cust_data`, data);
        return response;
    } catch (error) {
        throw handleApiError(error, 'Add_new_cust_data');
    }
};

export const Existing_CustList = async () => {
    try {
        console.log("data");
        const response = await axiosInstance.get(`/api/Existing_CustList`);
        return response;
    } catch (error) {
        throw handleApiError(error, 'Existing_CustList');
    }
};

export const Edit_Cust_Data = async (data) => {
    try {
        console.log(data);
        const response = await axiosInstance.put(`/api/Edit_cust_data`, data);
        return response;
    } catch (error) {
        throw handleApiError(error, 'Edit_Cust_Data');
    }
};

export const Edit_UserEmail = async (data) => {
    try {
        console.log(data);
        const response = await axiosInstance.put(`/api/Edit_UserEmail`, data);
        return response;
    } catch (error) {
        throw handleApiError(error, 'Edit_UserEmail');
    }
};

export const get_special_pricing_list_api = async () => {
    try {
        const response = await axiosInstance.get(`/api/get_special_pricing_list`);
        return response;
    } catch (error) {
        throw handleApiError(error, 'get_special_pricing_list_api');
    }
};

export const get_pymtplan_dropdown_api = async () => {
    try {
        const response = await axiosInstance.get(`/api/get_pymtplan_dropdown`);
        return response;
    } catch (error) {
        throw handleApiError(error, 'get_pymtplan_dropdown_api');
    }
};

export const add_special_pricing_api = async (data) => {
    try {
        const response = await axiosInstance.post(`/api/add_special_pricing`, data);
        return response;
    } catch (error) {
        throw handleApiError(error, 'add_special_pricing_api');
    }
};

export const edit_special_pricing_api = async (data) => {
    try {
        const response = await axiosInstance.post(`/api/edit_special_pricing`, data);
        return response;
    } catch (error) {
        throw handleApiError(error, 'edit_special_pricing_api');
    }
};

export const cuzbatch_filter = async (data) => {
    try {
        console.log(data);
        const response = await axiosInstance.get(`/api/cuzbatch_filter`, data);
        return response;
    } catch (error) {
        throw handleApiError(error, 'cuzbatch_filter');
    }
};

//   Add Location 
export const Add_Location_Data = async (data) => {
    try {
        console.log(data);
        const response = await axiosInstance.put(`/api/Add_Location_Data`, data);
        return response;
    } catch (error) {
        throw handleApiError(error, 'Add_Location_Data');
    }
};

export const Get_Topic_Location = async (data) => {
    try {
        console.log(data);
        const response = await axiosInstance.put(`/api/Get_Topic_Location`, data);
        return response;
    } catch (error) {
        throw handleApiError(error, 'Get_Topic_Location');
    }
};

export const Get_Location = async (data) => {
    try {
        console.log(data);
        const response = await axiosInstance.put(`/api/Get_Location`, data);
        return response;
    } catch (error) {
        throw handleApiError(error, 'Get_Location');
    }
};

export const Get_Topic_User_Location = async (data) => {
    try {
        console.log(data);
        const response = await axiosInstance.put(`/api/Get_Topic_User_Location`, data);
        return response;
    } catch (error) {
        throw handleApiError(error, 'Get_Topic_User_Location');
    }
};

export const Add_User_Topic_Location_Data = async (data) => {
    try {
        console.log(data);
        const response = await axiosInstance.put(`/api/Add_User_Topic_Location_Data`, data);
        return response;
    } catch (error) {
        throw handleApiError(error, 'Add_User_Topic_Location_Data');
    }
};

export const Add_Topic_Location_Data = async (data) => {
    try {
        console.log(data);
        const response = await axiosInstance.put(`/api/Add_Topic_Location_Data`, data);
        return response;
    } catch (error) {
        throw handleApiError(error, 'Add_Topic_Location_Data');
    }
};

export const Assign_Users_Locations = async (data) => {
    try {
        console.log(data);
        const response = await axiosInstance.put(`/api/Assign_Users_Locations`, data);
        return response;
    } catch (error) {
        throw handleApiError(error, 'Assign_Users_Locations');
    }
};

export const Assign_Users_Locations1 = async (data) => {
    try {
        const response = await axiosInstance.put(`/api/Assign_Users_Locations1`, data);
        return response;
    } catch (error) {
        throw handleApiError(error, 'Assign_Users_Locations1');
    }
};

export const Validate_UserEmail = async (data) => {
    try {
        console.log(data);
        const response = await axiosInstance.put(`/api/Validate_UserEmail`, data);
        return response;
    } catch (error) {
        throw handleApiError(error, 'Validate_UserEmail');
    }
};

export const Get_customer_custlocid = async (data) => {
    try {
        console.log(data);
        const response = await axiosInstance.put(`/api/Get_customer_custlocid`, data);
        return response;
    } catch (error) {
        throw handleApiError(error, 'Get_customer_custlocid');
    }
};

export const Add_Users_Data = async (data) => {
    try {
        console.log(data);
        const response = await axiosInstance.put(`/api/Add_Users_Data`, data);
        return response;
    } catch (error) {
        throw handleApiError(error, 'Add_Users_Data');
    }
};

export const Get_custloc_combinations = async (data) => {
    try {
        console.log(data);
        const response = await axiosInstance.put(`/api/Get_custloc_combinations`, data);
        return response;
    } catch (error) {
        throw handleApiError(error, 'Get_custloc_combinations');
    }
};

export const Add_User_Location = async (data) => {
    try {
        console.log(data);
        const response = await axiosInstance.put(`/api/Add_User_Location`, data);
        return response;
    } catch (error) {
        throw handleApiError(error, 'Add_User_Location');
    }
};

export const Demo_weclcome_email = async (data) => {
    try {
        console.log(data);
        const response = await axiosInstance.put(`/api/Demo_weclcome_email`, data);
        return response;
    } catch (error) {
        throw handleApiError(error, 'Demo_weclcome_email');
    }
};

export const sectionselect_reportinglist_api = async (data) => {
    try {
        console.log(data);
        const response = await axiosInstance.get(`/api/sectionselect_reportinglist?customerid=${data}`);
        return response;
    } catch (error) {
        throw handleApiError(error, 'sectionselect_reportinglist_api');
    }
};

export const sectionselect_custlocidlist_api = async (data) => {
    try {
        console.log(data);
        const response = await axiosInstance.get(`/api/sectionselect_custlocidlist?customerid=${data}`);
        return response;
    } catch (error) {
        throw handleApiError(error, 'sectionselect_custlocidlist_api');
    }
};

export const add_grouping_api = async (data) => {
    try {
        console.log(data);
        const response = await axiosInstance.post(`/api/Add_grouping`,data);
        return response;
    } catch (error) {
        throw handleApiError(error, 'add_grouping_api');
    }
};

export const edit_grouping_api = async (data) => {
    try {
        console.log(data);
        const response = await axiosInstance.put(`/api/Edit_grouping`,data);
        return response;
    } catch (error) {
        throw handleApiError(error, 'edit_grouping_api');
    }
};

export const delete_grouping_api = async (data) => {
    try {
        console.log(data);
        const response = await axiosInstance.post(`/api/delete_grouping`,data);
        return response;
    } catch (error) {
        throw handleApiError(error, 'delete_grouping_api');
    }
};

export const Get_customer_Custgroup = async (data) => {
    try {
        console.log(data);
        const response = await axiosInstance.put(`/api/Get_customer_Custgroup`, data);
        return response;
    } catch (error) {
        throw handleApiError(error, 'Get_customer_Custgroup');
    }
};

// ----------------------------------------------------------------------------

// add topics to location

export const report_group_topic_location_api = async ({customerid}) => {
    try {
        const response = await axiosInstance.get(`/api/report_group_topic_location_desc?customerid=${customerid}`);
        return response;
    } catch (error) {
        throw handleApiError(error, 'report_group_topic_location_api');
    }
};

// ------------------------------ get Ai Templates -----------------------------

export const get_ai_templates_data = async ({customerid}) => {
    try {
        console.log("customer_id", customerid);
        const response = await axiosInstance.get(`/api/get_ai_templates?customerid=${customerid}`);
        return response;
    } catch (error) {
        throw handleApiError(error, 'get_ai_templates_data');
    }
};

export const get_ai_templates_parameters = async ({templ_typeid}) => {
    try {
        const response = await axiosInstance.get(`/api/get_ai_templates_parameters?templ_typeid=${templ_typeid}`);
        return response;
    } catch (error) {
        throw handleApiError(error, 'get_ai_templates_parameters');
    }
};

export const update_ai_query_parameters = async (data) => {
    try {
        const response = await axiosInstance.post(`/api/update_ai_query_parameters`, data);
        return response;
    } catch (error) {
        throw handleApiError(error, 'update_ai_query_parameters');
    }
};

export const get_Ai_Query_Results = async ({customerid}) => {
    try {
        const response = await axiosInstance.get(`/api/get_ai_query_results?customerid=${customerid}`);
        return response;
    } catch (error) {
        throw handleApiError(error, 'get_Ai_Query_Results');
    }
};

export const get_ai_query_detailed_results = async ({Query_Code}) => {
    try {
        const response = await axiosInstance.get(`/api/get_ai_query_detailed_results?Query_Code=${Query_Code}`);
        return response;
    } catch (error) {
        throw handleApiError(error, 'get_ai_query_detailed_results');
    }
};

export const get_available_custom_topics = async (customer_id) => {
    try {
        const response = await axiosInstance.get(`/api/get_available_custom_topics?customer_id=${customer_id}`);
        return response;
    } catch (error) {
        throw handleApiError(error, 'get_available_custom_topics');
    }
};

export const create_custom_topic = async (data) => {
    try {
        const response = await axiosInstance.post(`/api/create_custom_topic`, data);
        return response;
    } catch (error) {
        throw handleApiError(error, 'create_custom_topic');
    }
};

export const get_AI_Assistant_Question_Results_list_Edit = async ({Query_Code, QR_Code}) => {
    try {
        const response = await axiosInstance.get(`/api/get_AI_Assistant_Question_Results_list_Edit?Query_Code=${Query_Code}&QR_Code=${QR_Code}`);
        return response;
    } catch (error) {
        throw handleApiError(error, 'get_AI_Assistant_Question_Results_list_Edit');
    }
};

export const update_AI_Assistant_Question_Result = async (data) => {
    try {
        console.log(data);
        const response = await axiosInstance.put(`/api/update_AI_Assistant_Question_Result`,data);
        return response;
    } catch (error) {
        throw handleApiError(error, 'update_AI_Assistant_Question_Result');
    }
};
